import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import CryptoJS from 'crypto-js'
import ActionData from '../../../../types/ActionData'
import Authorization from '../../../../types/Authorization'
import Organization from '../../../../types/Organization'
import Provider from '../../../../types/Provider'
import RootState from '../../../../types/RootState'
import User from '../../../../types/User'
import moment from 'moment'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import AuthorizationDetailModal from '../../../../components/Modals/AuthorizationDetailModal'
import DatePicker from 'react-datepicker'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import paginationFactory, { PaginationProvider, PaginationTotalStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Accordion, Button, Card, Col, Form, Row } from 'react-bootstrap'
import { formatDate, formatPhoneNumber, convert } from '../../../../utils/dataTools'
import { getOrgAuthorizations } from '../../../../redux/actions/authorization'
import { addUserActivity } from '../../../../redux/actions/authentication'
import { CSVLink } from 'react-csv'
import './index.css'
import { truncate, formatNoUTCDate, formatUTCDate } from '../../../../utils/stringTools'

interface Props {
  authorizations: Array<Authorization>;
  height: number;
  orgAuthorizationsData: ActionData;
  orgAuthorizationsPagination: {
    sizePerPage: number;
    totalSize: number;
  };
  csvOrgAuthorizations: ActionData;
  selectedOrganization: Organization;
  selectedProvider: Provider;
  user: User;
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number; authorizationId?: number }, token: string ) => void;
  getOrgAuthorizations: (id: number, page: number, sizePerPage: number, searchTerm: string, startDate: string, endDate: string, filterByAuthStatus: string, sortField: string, sortOrder: string, endDateFrom: string, endDaTeTo: string, type: string, token: string) => void;
}

class Authorizations extends Component<Props> {
  private csvLink: any = createRef()

  state = {
    //Search
    searchOpen: false,
    endDate: undefined,
    startDate: undefined,
    endDateFrom: undefined,
    endDateTo: undefined,
    searchTerm: '',
    //Filter
    filterByAuthStatus: 'all',
    //Authorizations
    selectedAuthorization: {
      lastStatusChangeDate: '',
      authorizationId: -1,
      authorizationNumber: '',
      authorizationStartDate: '',
      authorizationEndDate: '',
      authDetails: '',
      careManager: '',
      careManagerPhone: '',
      currentStatus: '',
      tcFrequency: '',
      memberId: -1,
      memberName: '',
      memberMci: '',
      memberSsn: '',
      memberDob: '',
      procedureName: '',
      serviceCategory: '',
      revisionIndicator: '',
      rn: '',
      rnPhone: '',
      tcUnitsPerFrequency: -1,
      serviceCode: '',
      tcTotalUnits: 0,
      tcCostOverride: 0,
      tcNegotiatedRate: 0
    },
    show: false,
    page: 1,
    totalSize: 0,
    sortField: null,
    sortOrder: null
  }

  componentDidMount() {
    const { orgAuthorizationsPagination, selectedOrganization, getOrgAuthorizations } = this.props

    if ( selectedOrganization.organization_id !== -1 ) {
      const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
      if ( token && token !== '' ) {
        getOrgAuthorizations(selectedOrganization.organization_id, 1, orgAuthorizationsPagination.sizePerPage, null, null, null, null, null, null, null, null, 'PAGING', token)
        this.setState({ page: 1 })
      }
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { orgAuthorizationsPagination, selectedOrganization, csvOrgAuthorizations, getOrgAuthorizations } = this.props

    if ( selectedOrganization !== prevProps.selectedOrganization && selectedOrganization.organization_id !== -1 ) {
      const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : 'y'

      if ( token && token !== '' ) {
        getOrgAuthorizations(selectedOrganization.organization_id, 1, orgAuthorizationsPagination.sizePerPage, null, null, null, null, null, null, null, null, 'PAGING', token)
        this.setState({ page: 1 })
      }
    }

    if ( orgAuthorizationsPagination !== prevProps.orgAuthorizationsPagination ) {
      this.setState({ totalSize: orgAuthorizationsPagination.totalSize })
    }

    if ( csvOrgAuthorizations !== prevProps.csvOrgAuthorizations ) {
      if (csvOrgAuthorizations.data && this.csvLink.current && this.csvLink.current.link) {
        setTimeout(() => {
          this.csvLink.current.link.click()
        })
      }
    }
  }

  applyFilters = () => {
    const { selectedOrganization, orgAuthorizationsPagination, getOrgAuthorizations } = this.props
    const { startDate, endDate, searchTerm, filterByAuthStatus, sortField, sortOrder, endDateFrom, endDateTo } = this.state
    const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
    
    getOrgAuthorizations(selectedOrganization.organization_id, 1, orgAuthorizationsPagination.sizePerPage, searchTerm, convert(startDate), convert(endDate), filterByAuthStatus, sortField, sortOrder, convert(endDateFrom), convert(endDateTo), 'PAGING', token)
    this.setState({ page: 1 })
  }

  clearFilters = () => {
    const { sortField, sortOrder } = this.state
    const { selectedOrganization, orgAuthorizationsPagination, getOrgAuthorizations } = this.props
    const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
    
    getOrgAuthorizations(selectedOrganization.organization_id, 1, orgAuthorizationsPagination.sizePerPage, null, null, null, null, sortField, sortOrder, null, null, 'PAGING', token)
    this.setState({
      endDate: undefined,
      searchTerm: '',
      startDate: undefined,
      filterByAuthStatus: 'all',
      page: 1,
    })
  }

  closeModal = () => {
    this.setState({
      selectedAuthorization: {
        lastStatusChangeDate: '',
        authorizationId: -1,
        authorizationNumber: '',
        authorizationStartDate: '',
        authorizationEndDate: '',
        careManager: '',
        currentStatus: '',
        tcFrequency: '',
        memberId: -1,
        memberName: '',
        memberMci: '',
        memberSsn: '',
        procedureName: '',
        serviceCategory: '',
        revisionIndicator: '',
        rn: '',
        tcUnitsPerFrequency: -1,
        serviceCode: '',
        tcTotalUnits: 0,
        tcCostOverride: 0,
        tcNegotiatedRate: 0
      },
      show: false
    })
  }

  formatAuthDataForCSV = (authorizations: Array<Authorization>) => {
    let data = authorizations
    if (!data || data === undefined || data.length === 0) {
      return []
    }
    const csv = data.map(auth => ({
      'Member ID': auth.memberId,
      'Member Name': auth.memberName.trim() !== ',' ? auth.memberName : '',
      'Member DOB': formatUTCDate(auth.memberDob),
      'MCI': auth.memberMci,
      'SSN': auth.memberSsn,
      'Care Manager': auth.careManager,
      'Care Manager Phone': formatPhoneNumber(auth.careManagerPhone),
      'RN': auth.rn,
      'RN Phone': formatPhoneNumber(auth.rnPhone),
      'Auth No': auth.authorizationNumber,
      'Entered On Date': formatNoUTCDate(truncate(10, auth.lastStatusChangeDate)),
      'Service Code': auth.serviceCode,
      'Service Type': auth.serviceCategory,
      'Procedure': auth.procedureName,
      'Service Provider': auth.serviceProvider,
      'Provider Address': auth.providerAddress,
      'Provider Phone': formatPhoneNumber(auth.providerPhone),
      'Service Start Date': formatNoUTCDate(formatDate(auth.authorizationStartDate)),
      'Service End Date': formatNoUTCDate(formatDate(auth.authorizationEndDate)),
      'Units': auth.tcUnitsPerFrequency,
      'Frequency': auth.tcFrequency,
      'Total Units': auth.tcTotalUnits,
      'Unit Rate': auth.tcCostOverride !== null && auth.tcCostOverride !== undefined ? auth.tcCostOverride : ( auth.tcNegotiatedRate !== null && auth.tcNegotiatedRate !== undefined ? auth.tcNegotiatedRate : 'See Contracted Rates' ),
      'Status': auth.currentStatus,
      'Auth Status': auth.revisionIndicator === 'C' ? 'VOID' : (moment(moment(formatDate(auth.authorizationEndDate))).isSameOrAfter(moment()) ? 'OPEN' : 'CLOSED'),
      'Cancel Auth': auth.revisionIndicator === 'C' ? 'Yes' : 'No',
      'Revised': auth.revisionIndicator === '1' ? 'Yes' : 'No',
      'Details': auth.authDetails ? auth.authDetails.replace(/(?:\r\n|\r|\n)/g, ' ').replace('"', '""') : ''
    }))
    return csv
  }

  handleChangeDate = (date: Date, name: string) => {
    this.setState({
      [name]: date
    })
  }

  handleChangeString = (evt: any) => {
    this.setState({ [evt.target.name]: evt.target.value })
  }

  handleDownloadPdf = () => {
    const input = document.getElementById('downloadPdf')
    if (input !== null) {
      input.style.width = '700px'

      html2canvas(input)
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/png')

          const pdf = new jsPDF()
          pdf.addImage(imgData, 'PNG', 10, 10, canvas.width, canvas.height)
          pdf.save('authorization.pdf')

          input.style.width = '75%'
        })
    }
  }

  handleSearchIconClicked = () => {
    this.setState({
      searchOpen: !this.state.searchOpen
    })
  }

  openModal = (row: any, show: boolean) => {
    const { user, addUserActivity } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''

    this.setState({
      selectedAuthorization: row,
      show
    })

    addUserActivity({
      eid: email.eid,
      activity: 'View Authorization',
      authorizationId: row.authorizationId,
    }, token)
  }

  handlePageChange = (page, sizePerPage) => {
    const { selectedOrganization, getOrgAuthorizations } = this.props
    const { startDate, endDate, searchTerm, filterByAuthStatus, sortField, sortOrder, endDateFrom, endDateTo } = this.state
    const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
    
    this.setState({ page })
    getOrgAuthorizations(selectedOrganization.organization_id, page, sizePerPage, searchTerm, convert(startDate), convert(endDate), filterByAuthStatus, sortField, sortOrder, convert(endDateFrom), convert(endDateTo), 'PAGING', token)
  }
  
  handleTableChange = (type, { sortField, sortOrder }) => {
    // handle any data change here
    if ( type === 'sort') {
      const { orgAuthorizationsPagination, selectedOrganization, getOrgAuthorizations } = this.props
      const { startDate, endDate, searchTerm, filterByAuthStatus, page, endDateFrom, endDateTo } = this.state
      const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token') || '') : ''
      
      this.setState({ sortField, sortOrder })
      getOrgAuthorizations(selectedOrganization.organization_id, page, orgAuthorizationsPagination.sizePerPage, searchTerm, convert(startDate), convert(endDate), filterByAuthStatus, sortField, sortOrder, convert(endDateFrom), convert(endDateTo), 'PAGING', token)
    }
  }

  handleDownloadActivity = () => {
    const { selectedOrganization, orgAuthorizationsPagination, user, addUserActivity, getOrgAuthorizations } = this.props
    const { startDate, endDate, searchTerm, filterByAuthStatus, sortField, sortOrder, endDateFrom, endDateTo } = this.state
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''

    getOrgAuthorizations(selectedOrganization.organization_id, 1, orgAuthorizationsPagination.sizePerPage, searchTerm, convert(startDate), convert(endDate), filterByAuthStatus, sortField, sortOrder, convert(endDateFrom), convert(endDateTo), 'CSV', token)
    addUserActivity({
      eid: email.eid,
      activity: 'Download Authorizations',
      organizationId: selectedOrganization.organization_id
    }, token)
  }

  render() {
    const { authorizations, height, orgAuthorizationsData, orgAuthorizationsPagination, csvOrgAuthorizations, selectedProvider } = this.props
    const { endDate, filterByAuthStatus, selectedAuthorization, show, startDate, searchTerm, totalSize, page, endDateFrom, endDateTo } = this.state

    const columns = [{
      dataField: 'authorizationNumber',
      text: 'Auth No',
      sort: true
    }, {
      dataField: 'memberName',
      text: 'Member Name',
      sort: true,
      formatter: (cellContent) => cellContent.trim() !== ',' ? cellContent : ''
    }, {
      dataField: 'serviceCode',
      text: 'Service Code',
      sort: true
    }, {
      dataField: 'procedureName',
      text: 'Procedure',
      sort: true
    }, {
      dataField: 'authorizationStartDate',
      text: 'Service Start',
      sort: true,
      formatter: (cellContent) => formatNoUTCDate(formatDate(cellContent))
    }, {
      dataField: 'authorizationEndDate',
      text: 'Service End',
      sort: true,
      formatter: (cellContent) => formatNoUTCDate(formatDate(cellContent))
    }, {
      dataField: 'lastStatusChangeDate',
      text: 'Entered On Date',
      sort: true,
      formatter: (cellContent) => formatNoUTCDate(truncate(10, cellContent))
    }, {
      dataField: 'revisionIndicator',
      text: 'Revised',
      sort: true,
      formatter: (cellContent) => cellContent === '1' ? 'Yes' : 'No'
    }, {
      dataField: 'authStatus',
      text: 'Auth Status',
      sort: true,
      formatter: (cellContent, row) => row.revisionIndicator === 'C' ? 'VOID' : (moment(moment(formatDate(row.authorizationEndDate))).isSameOrAfter(moment()) ? 'OPEN' : 'CLOSED')
    }]

    const rowEvents = {
      onClick: (e, row) => {
        this.openModal(row, true)
      }
    }

    let data = <div>No Authorizations available</div>

    if (orgAuthorizationsData.loading === true)
      data = (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
          <CircularProgress size={40} />
          <span>Loading data</span>
        </div>
      )

    const csvData = this.formatAuthDataForCSV(csvOrgAuthorizations.data)
    return (
      <div>
        <Accordion style={{ marginBottom: 20, borderBottom: '1px solid rgba(0, 0, 0, 0.125)' }} defaultActiveKey='0'>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant='link' eventKey='0'>
                Search Authorizations
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey='0'>
              <Card.Body>
                <Row>
                  <Col xs={3}>
                    <Form.Group>
                      <Form.Label>Authorizations Active Between</Form.Label>
                      <DatePicker
                        selected={startDate}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        onChange={(date: Date) => this.handleChangeDate(date, 'startDate')}
                        className='datepicker'
                        placeholderText='Auth Started On/After'
                        dateFormat='MM/dd/yyyy'
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={3}>
                    <Form.Group>
                      <div style={{ height: '2rem' }} />
                      <DatePicker
                        selected={endDate}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        onChange={(date: Date) => this.handleChangeDate(date, 'endDate')}
                        minDate={startDate}
                        className='datepicker'
                        placeholderText='Auth Ended On/Before'
                        dateFormat='MM/dd/yyyy'
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label>Member Name, Procedure, or Authorization No.</Form.Label>
                      <Form.Control
                        placeholder='Enter Member Name, Procedure, or Authorization No.'
                        aria-label='Enter Member Name, Procedure, or Authorization No.'
                        name='searchTerm'
                        value={searchTerm}
                        onChange={this.handleChangeString}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={3}>
                    <Form.Group>
                      <Form.Label>Authorization Start Date</Form.Label>
                      <Form.Label></Form.Label>
                      <DatePicker
                        selected={endDateFrom}
                        selectsStart
                        startDate={endDateFrom}
                        endDate={endDateTo}
                        onChange={(date: Date) => this.handleChangeDate(date, 'endDateFrom')}
                        className='datepicker'
                        placeholderText='Start Range'
                        dateFormat='MM/dd/yyyy'
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={3}>
                    <Form.Group>
                      <div style={{ height: '2rem' }} />
                      <DatePicker
                        selected={endDateTo}
                        selectsEnd
                        startDate={endDateFrom}
                        endDate={endDateTo}
                        onChange={(date: Date) => this.handleChangeDate(date, 'endDateTo')}
                        minDate={endDateFrom}
                        className='datepicker'
                        placeholderText='End Range'
                        dateFormat='MM/dd/yyyy'
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={3}>
                    <Form.Group>
                      <Form.Label>Authorization Status</Form.Label>
                      <Form.Control as='select' name='filterByAuthStatus' value={filterByAuthStatus} onChange={this.handleChangeString}>
                        <option value='all'>ALL</option>
                        <option value='open'>OPEN</option>
                        <option value='closed'>CLOSED</option>
                        <option value='void'>VOID</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 2, offset: 8 }}>
                    <Button variant='outline-secondary' block onClick={this.clearFilters} style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block' }}>Clear</Button>
                  </Col>
                  <Col xs={2}>
                    <Button variant='success' block onClick={() => { this.applyFilters() }} style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block' }}>Search</Button>
                  </Col>
                </Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
        <div style={{ height: height - 357 }}>
          <PaginationProvider
            pagination={paginationFactory({
              custom: true,
              page: page,
              totalSize: totalSize,
              sizePerPage: orgAuthorizationsPagination.sizePerPage,
              onPageChange: this.handlePageChange
            })}
          >
            {
              ({
                paginationProps,
                paginationTableProps,
              }) => (
                <div>
                  <ToolkitProvider
                    keyField='authorizationId'
                    bootstrap4
                    data={authorizations}
                    columns={columns}
                    search
                  >
                    {
                      props => (
                        <div className='authorizations-table-container' style={{ width: '100%' }}>
                          {
                            csvOrgAuthorizations.loading ? (
                              <div style={{ float: 'right', paddingBottom: 10 }}>
                                <Button variant='success' disabled>
                                  <div>Downloading <CircularProgress size={10} style={{ marginLeft: 10, color: 'white' }} /></div>
                                </Button>
                              </div>
                            ) :
                              csvData.length > 0 ? (
                                <CSVLink ref={this.csvLink} data={csvData} filename={`${selectedProvider.provider_name}_Authorizations_${moment().format('YYYY-MM-DD')}.csv`} style={{ float: 'right', paddingBottom: 10 }}>
                                  <Button variant='success'>
                                    Download
                                  </Button>
                                </CSVLink>
                              ) : (
                                <div style={{ float: 'right', paddingBottom: 10 }}>
                                  <Button variant='success' onClick={this.handleDownloadActivity}>
                                    Download
                                  </Button>
                                </div>
                              )
                          }
                          <BootstrapTable
                            id='authorizations_table'
                            bordered={false}
                            remote
                            striped
                            condensed
                            bootstrap4
                            rowEvents={rowEvents}
                            noDataIndication={() => (data)}
                            onTableChange={this.handleTableChange}
                            {...paginationTableProps}
                            {...props.baseProps}
                          />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                  <PaginationTotalStandalone {...paginationProps} />
                  <PaginationListStandalone
                    {...paginationProps}
                  />
                </div>
              )
            }
          </PaginationProvider>
        </div>
        <AuthorizationDetailModal
          isOrganization={true}
          authorization={selectedAuthorization}
          provider={selectedProvider}
          show={show}
          onClose={this.closeModal}
          onDownloadPdf={this.handleDownloadPdf}
        />
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  csvOrgAuthorizations: state.authorization.csvOrgAuthorizations,
  orgAuthorizationsData: state.authorization.orgAuthorizations,
  orgAuthorizationsPagination: state.authorization.orgAuthorizations.pagination,
  authorizations: state.authorization.orgAuthorizations.data,
  selectedOrganization: state.authentication.selectedOrganization,
  user: state.authentication.user.data,
})

const mapDispatchToProps = {
  addUserActivity,
  getOrgAuthorizations
}

export default connect(mapStateToProps, mapDispatchToProps)(Authorizations)
